import { ca } from '@cian/analytics';
import { useUpdateEffect } from '@cian/react-utils';

import { FC } from 'react';

import { useGetCianAnalyticsPageViewObject } from 'shared/hooks/useGetCianAnalyticsPageViewObject';
import { useActivePinIdSelector } from 'shared/store/clientSide/slices/mapControls';

import { ListingByPinContainer } from './ListingByPinContainer';
import { ListingContainer } from './ListingContainer';

export const ApplicationListingContainer: FC = () => {
  const activePinId = useActivePinIdSelector();
  const getCianAnalyticsPageViewObject = useGetCianAnalyticsPageViewObject();

  useUpdateEffect(() => {
    if (activePinId == null) {
      const cianAnalyticsPageViewObject = getCianAnalyticsPageViewObject();

      ca('pageviewSite', cianAnalyticsPageViewObject);
    }
  }, [activePinId]);

  return activePinId ? <ListingByPinContainer /> : <ListingContainer />;
};
